import {Component, ContentChild, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {AbstractControl, FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ContentDirective} from '../../../../shared/directives/content.directive';
import {CoerceBoolean} from '../../../../shared/utils/coercion.utils';

@Component({
  selector: 'app-form-array-input',
  templateUrl: './form-array-input.component.html',
})
export class FormArrayInputComponent {

  public static readonly COLLAPSED_CONTROL_NAME = 'form_array_collapsed';

  @ContentChild(ContentDirective, { static: true, read: TemplateRef }) template: TemplateRef<any>;

  @Input() accordion = false;
  @Input() itemInCard = false;
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() addItemLabel: string;
  @Input() minElementSize = -1;
  @Input() maxElementSize = -1;
  @Input() @CoerceBoolean() mustConfirmDeletion = false;
  @Input() buildNewItemForm: (v?: any) => UntypedFormGroup;
  @Input() canReorder = false;
  @Input() noItemLabel: string = undefined;
  @Input() collapsible = false;
  @Input() title: string;

  @Input() deletable = true;
  @Output() itemAddedEvent = new EventEmitter<FormGroup>();
  @Output() deletedEvent = new EventEmitter<FormArrayInputDeletedEvent>();
  @Output() reorderedEvent = new EventEmitter<FormArrayReorderEvent>();

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  onAddItem() {
    console.log('onAddItem', this.buildNewItemForm);
      if (this.buildNewItemForm) {
        const group = this.buildNewItemForm();
        if (!group.get(FormArrayInputComponent.COLLAPSED_CONTROL_NAME)) {
          group.addControl(FormArrayInputComponent.COLLAPSED_CONTROL_NAME, this.formBuilder.control(false));
        }
        this.formArrayControl.push(group);
        this.itemAddedEvent.emit(group);
      }
  }

  get formArrayControl(): UntypedFormArray {
      // // console.logByType['form array', this.parentFormGroup, this.parentFormControlName]);
    return this.parentFormGroup.get(this.parentFormControlName) as UntypedFormArray;
  }

  isCollapsed(index: number): boolean {
    let collapsed = false;
    if (this.formArrayControl.length > index) {
      // console.log([this.formArrayControl]);
      const control = this.formArrayControl.at(index).get(FormArrayInputComponent.COLLAPSED_CONTROL_NAME);
      if (control) {
        collapsed = control.value;
      }
    }
    return collapsed;
  }

  setCollapsed(collapsed: boolean, index: number) {
    for(let i = 0; i < this.formArrayControl.length; i++) {
      const formGroup: UntypedFormGroup = this.formArrayControl.at(i) as UntypedFormGroup;
      let control = formGroup.get(FormArrayInputComponent.COLLAPSED_CONTROL_NAME);
      if (!control) {
        control = this.formBuilder.control(undefined);
        formGroup.addControl('form_array_collapsed', control);
      }
      if (index === i) {
        control.setValue(collapsed);
      } else if (this.accordion && !collapsed) {
        control.setValue(true);
      }
    }
  }

  onDeletionConfirmed(index: number) {
    const controlToDelete = this.formArrayControl.at(index);
    this.formArrayControl.removeAt(index);
    if (this.deletedEvent) {
        this.deletedEvent.emit({
          control: controlToDelete,
          index
        });
    }
  }

  moveUp(index: number) {
    const control = this.formArrayControl.at(index);
    this.formArrayControl.removeAt(index);
    this.formArrayControl.insert(index - 1, control);
    this.reorderedEvent.emit({
      fromIndex: index,
      toIndex: index -1
    });
  }

    moveDown(index: number) {
      const control = this.formArrayControl.at(index);
      this.formArrayControl.removeAt(index);
      this.formArrayControl.insert(index + 1, control);
      this.reorderedEvent.emit({
        fromIndex: index,
        toIndex: index + 1
      });
    }

    canDeleted(): boolean {
      return this.deletable && (this.minElementSize < 0 || (this.formArrayControl?.length > this.minElementSize));
    }
}

export class FormArrayInputDeletedEvent {
  control: AbstractControl;
  index: number;
}

export class FormArrayReorderEvent {
  fromIndex: number;
  toIndex: number;
}
